"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const UnitInput = (props) => {
    var _a;
    return (React.createElement("div", { className: "unit-input" },
        React.createElement("div", { className: "unit-input-inner" },
            React.createElement("input", { id: props.id, type: "number", className: `form-control value ${props.className ? props.className : ''}`, value: props.currentValue, onChange: props.onChange, onBlur: props.onBlur, placeholder: props.placeholder, disabled: (_a = props.disabled) !== null && _a !== void 0 ? _a : false, min: props.minAmount, max: props.maxAmount }),
            React.createElement("div", { className: `unit ${props.disabled ? 'disabled' : ''}` }, props.unit)),
        props.errorMessage && (React.createElement("div", { className: "form-message message-error" }, props.errorMessage))));
};
exports.default = UnitInput;
//# sourceMappingURL=UnitInput.js.map